import moment from 'moment';
import { ACCOUNTS_PAYABLE, ACCOUNTS_RECEIVABLES, INVENTORY } from '../types';

export const compareBy = (keyName: string) => (a: any, b: any) => {
  if (a[keyName] < b[keyName]) {
    return -1;
  }

  if (a[keyName] > b[keyName]) {
    return 1;
  }

  return 0;
};

export const arrayMove = (arr: any[], oldIndex: number, newIndex: number) => {
  if (newIndex >= arr.length) {
    let k = newIndex - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr;
};

export const copyStringToBuffer = (value: string) => {
  const node = document.createElement('textarea');

  node.textContent = value;
  document.body.appendChild(node);

  node.select();
  document.execCommand('copy');

  document.body.removeChild(node);
};

export const downloadObjectAsJson = (
  exportObj: any,
  exportName: string,
  ext: string = 'json'
) => {
  const dataStr: string =
    'data:text/json;charset=utf-8,' +
    encodeURIComponent(JSON.stringify(exportObj));
  const downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute('href', dataStr);
  downloadAnchorNode.setAttribute('download', exportName + '.' + ext);
  document.body.appendChild(downloadAnchorNode);
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
};

export const truncateText = (input: string, maxLength: number) =>
  input.length > maxLength ? `${input.substring(0, maxLength)}...` : input;

export const sortByProperty =
  (prop: string, order: string) => (a: any, b: any) => {
    if (typeof a[prop] === 'number') {
      return order === 'asc' ? b[prop] - a[prop] : a[prop] - b[prop];
    } else {
      if (order === 'asc') {
        return a[prop] < b[prop] ? -1 : a[prop] > b[prop] ? 1 : 0;
      } else {
        return a[prop] > b[prop] ? -1 : a[prop] < b[prop] ? 1 : 0;
      }
    }
  };

export const getInitialsFromUserName = (fullName: string) => {
  if (!fullName) return '';

  return fullName
    .split(' ')
    .reverse()
    .map((n) => n?.[0] || '')
    .join('');
};

export const getFxrLink = (section: string, sessionId: string) => {
  const schemasMap = {
    [ACCOUNTS_PAYABLE]: 'Account Payables',
    [ACCOUNTS_RECEIVABLES]: 'Account Receivables',
    [INVENTORY]: 'Inventory',
  };

  const fxrUrl = process.env.REACT_APP_FXR_UI_URL;
  const mainAppUrl = encodeURIComponent(window.location.origin);
  const targetSchemaName = schemasMap[section];

  return `${fxrUrl}/files-validation/${sessionId}?mainAppUrl=${mainAppUrl}&targetSchemaName=${targetSchemaName}`;
};

export function getTotal<T extends { [key: string]: number | unknown }>(
  list: T[]
): T | null {
  if (!list || list.length === 0) return null;
  if (list.length === 1) return list[0];

  return list.reduce((acc: T, item: T) => {
    acc = { ...acc };

    const keys = Object.keys(item) as Array<keyof T>;

    keys.forEach((key: keyof T) => {
      if (typeof item[key] === 'number' && typeof acc[key] === 'number') {
        // TODO: check why this is not working
        // acc[key] = item[key] + acc[key];
        const a: number = item[key] as number;
        const b: number = acc[key] as number;
        const sum: any = a + b;

        acc[key] = sum;
      } else {
        acc[key] = item[key];
      }
    });

    return acc;
  });
}

export function timeLeft(targetDate: string) {
  const now = moment();
  const then = moment(targetDate);

  const days = then.diff(now, 'days');
  const hours = then.diff(now, 'hours');
  const minutes = then.diff(now, 'minutes');

  if (days >= 1) {
    const dayText = pluralize('day', days);
    return `${days} ${dayText}`;
  } else if (hours >= 1) {
    const hourText = pluralize('hour', hours);
    return `${hours} ${hourText}`;
  } else if (minutes >= 1) {
    const minuteText = pluralize('minute', minutes);
    return `${minutes} ${minuteText}`;
  }

  return '';
}

export function pluralize(word: string, count: number) {
  if (count === 1) {
    return word;
  } else {
    return word + 's';
  }
}
